// PrintPDF.js
import { useRef, useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import { Button, Alert } from "antd";
import NotifyGuarantor28 from "./NotifyGuarantor28";
import NotifyGuarantor3N from "./NotifyGuarantor3N";
import "./css/loadprint.css";

function PrintPDF({ dataTabelB, selectedContract, printingAll, setPrintingAll, roundDate }) {

  const [batchIndex, setBatchIndex] = useState(0);
  const [printing, setPrinting] = useState(false);
  const conponentPDF = useRef();

  const batchSize = 200; // ✅ แบ่งชุดละ 300
  const totalBatches = Math.ceil(dataTabelB.length / batchSize);
  const currentBatchNumber = batchIndex + 1;
  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: `ใบบอกกล่าวผู้ค้ำประกัน-${batchIndex + 1}`,
    onAfterPrint: () => {
      if ((batchIndex + 1) * batchSize < dataTabelB.length) {
        // พิมพ์ชุดถัดไป
        setBatchIndex(batchIndex + 1);
      } else {
        setPrinting(false);
        setPrintingAll(false); // ปลดล็อกปุ่มค้นหา
        setBatchIndex(0);
      }
    },
  });
  const handlePDF = () => {
    setPrinting(true);
    setPrintingAll(true); // บล็อกปุ่มค้นหา
  };

  useEffect(() => {
    if (printing) {
      generatePDF();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batchIndex, printing]);
  //ป้องกันค้นหา สัญญาไม่เจอ
  const safeData = Array.isArray(dataTabelB) ? dataTabelB : [];
  const currentBatch = safeData.slice(
    batchIndex * batchSize,
    (batchIndex + 1) * batchSize
  );

  return (
    <>
      <Button type="primary" onClick={handlePDF} disabled={printing} danger>
        {printing
          ? `กำลังพิมพ์ ${currentBatchNumber}/${totalBatches}`
          : `พิมพ์ PDF (${dataTabelB.length} ใบ)`}
      </Button>
          {/* render หน้ารายงานเมื่่อกดพิมพ์ PDF */}
      {printing &&
        (selectedContract?.key === "lsfhp" ? (
            <Alert message="บช 1 เอกสารไม่เสร็จ ตามกับทนายเด้อ" type="error" showIcon />
        ) : selectedContract?.key === "psfhp" || selectedContract?.key === "rpsl" ? (
            <div className="print-only" ref={conponentPDF}>
            {currentBatch.map((item, index) => (
              <NotifyGuarantor3N key={index} dataTabelB={item} selectedContract={selectedContract} indexA={index} indexB={currentBatchNumber} roundDate={roundDate}/>
            ))}
          </div>
        ) : (
          <div className="print-only" ref={conponentPDF}>
            {currentBatch.map((item, index) => (
              <NotifyGuarantor28 key={index} dataTabelB={item} selectedContract={selectedContract} indexA={index} indexB={currentBatchNumber} roundDate={roundDate}/>
            ))}
          </div>
        ))}
    </>
  );
}
export default PrintPDF;
